import PropTypes from 'prop-types'
import { Box, Button, Checkbox, HStack, Text, VStack } from '@chakra-ui/react'
import React, { memo, useMemo } from 'react'
import InputForm from '../../InputForm/InputForm'
import Selector from '../../Selector/Selector'
import { REPOSITORY } from '../../../api/repository/Repository'
import useFilters from './useFilters'
import { statusTypes } from '../TableCells/StatusCell/StatusCell'
const searchByOptions = [
  { id: 'dni', label: 'RUT', value: 'dni' },
  { id: 'name', label: 'Nombre o NN', value: 'name' },
]
const employeeTypeOptions = [
  { id: 'NO', label: 'Nominativa', value: 'NO' },
  { id: 'NN', label: 'No Nominativa', value: 'NN' },
]

const SelectorFilter = memo(({ options, onChange, title }) => {
  return (
    <HStack
      spacing={0}
      wrap="wrap"
      alignItems="center"
      justifyContent="flex-start"
    >
      <Box minWidth="160px">
        <Text>{title}</Text>
      </Box>
      <Box minW="155px">
        <Selector
          placeholder="Todas"
          isClearable
          options={options}
          onChange={onChange}
        />
      </Box>
    </HStack>
  )
})

SelectorFilter.displayName = 'SelectorFilter'
SelectorFilter.propTypes = {
  onChange: PropTypes.func,
  options: PropTypes.array,
  title: PropTypes.string,
  spacing: PropTypes.string,
}
export default function Filters({ handleSearch }) {
  const {
    status,
    filters,
    searchBy,
    filtersFunctions: {
      handleSearchBy,
      handleChangeStatus,
      handleChangeBranch,
      handleChangeCostCenter,
      handleChangeGroup,
      handleChangeName,
      handleChangeEmployeeType,
      handleChangeDni,
    },
  } = useFilters()
  const { sSucursal, sCentroCosto, lGrupo } = useMemo(
    () => REPOSITORY.local.company.getCompanyData(),
    [],
  )
  return (
    <VStack alignItems="stretch" width="100%" spacing="20px">
      <HStack
        spacing={0}
        gap={'16px'}
        wrap="wrap"
        w="100%"
        alignItems="flex-end"
        mt={['dni', 'name'].includes(searchBy) ? 0 : '28px'}
      >
        <SelectorFilter
          title="Buscar por"
          onChange={handleSearchBy}
          options={searchByOptions}
        />
        {searchBy && (
          <Box w="200px">
            <InputForm
              variant="subtitle3"
              value={searchBy === 'dni' ? filters?.sRut : filters?.sNombre}
              onChange={searchBy === 'dni' ? handleChangeDni : handleChangeName}
              title={
                searchBy === 'dni'
                  ? 'RUT de colaborador'
                  : 'Nombre de colaborador'
              }
            />
          </Box>
        )}
      </HStack>
      <HStack spacing={0} w="100%" alignItems="center">
        <Box minWidth="160px">
          <Text>Estado Colaborador</Text>
        </Box>
        <HStack spacing={0} w="75%" wrap="wrap" alignItems="flex-start">
          {status.map((item) => (
            <Checkbox
              marginRight="16px !important"
              key={`check-${item}`}
              value={item}
              onChange={handleChangeStatus}
              defaultChecked={filters.sEstado.includes(item)}
            >
              {statusTypes[item || '']}
            </Checkbox>
          ))}
        </HStack>
      </HStack>
      <SelectorFilter
        options={employeeTypeOptions}
        onChange={handleChangeEmployeeType}
        title={'Tipo de bolsillo'}
      />
      <SelectorFilter
        options={sSucursal}
        onChange={handleChangeBranch}
        title={'Sucursal'}
      />
      <SelectorFilter
        options={sCentroCosto}
        onChange={handleChangeCostCenter}
        title={'Centro de costo'}
      />
      <SelectorFilter
        options={lGrupo}
        onChange={handleChangeGroup}
        title={'Grupo'}
      />
      <Box w="159px" h="65px">
        <Button
          borderRadius="6px"
          variant="secondary"
          onClick={() => handleSearch(filters)}
        >
          <Text color="#FFFFFF">Buscar</Text>
        </Button>
      </Box>
    </VStack>
  )
}

Filters.propTypes = {
  filters: PropTypes.object,
  handleChangeAsc: PropTypes.func,
  handleChangeBranch: PropTypes.func,
  handleChangeCostCenter: PropTypes.func,
  handleChangeDni: PropTypes.func,
  handleChangeEmployeeType: PropTypes.func,
  handleChangeGroup: PropTypes.func,
  handleChangeName: PropTypes.func,
  handleChangeOrderBy: PropTypes.func,
  handleChangeStatus: PropTypes.func,
  handleSearch: PropTypes.func,
  handleSearchBy: PropTypes.func,
  searchBy: PropTypes.string,
}
